import { baseThunk } from '../../fetch/basicThunk';
import { QUERY_GET_ROLES } from '../../fetch/constantQueries';

export const getRoles = baseThunk(`roles/getRoles`, QUERY_GET_ROLES, "GET");